import { render } from "./EditClient.vue?vue&type=template&id=073abe29&scoped=true"
import script from "./EditClient.vue?vue&type=script&lang=js"
export * from "./EditClient.vue?vue&type=script&lang=js"

import "./EditClient.vue?vue&type=style&index=0&id=073abe29&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-073abe29"]])

export default __exports__
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QBtnToggle from 'quasar/src/components/btn-toggle/QBtnToggle.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QBtnDropdown from 'quasar/src/components/btn-dropdown/QBtnDropdown.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QField from 'quasar/src/components/field/QField.js';
import QInput from 'quasar/src/components/input/QInput.js';import Ripple from 'quasar/src/directives/Ripple.js';
import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCardSection,QAvatar,QImg,QIcon,QBtn,QMenu,QList,QItem,QItemSection,QTooltip,QSelect,QChip,QItemLabel,QBtnToggle,QExpansionItem,QTable,QBtnDropdown,QSpace,QTd,QCheckbox,QDialog,QField,QInput});qInstall(script, 'directives', {Ripple,ClosePopup});
